const popupMapRu = {
  popupMap: {
    label: "Новая локация",
    locationName: "Наименование локации",
    coordinates: "Координаты",
  },
};
export { popupMapRu };
